import React, { useCallback, useState } from 'react';
import { FormWithPrivacyHandler } from 'components/molecules/custom-form';
import styles from 'components/organisms/document/parts/doc-discussions/discussions-components/reply-comment.module.css';
import {
  useProjectAsRBACResource,
  useWithAccess,
} from 'hooks/rbac/useWithAccess';
import { useTranslation } from 'hooks/use-translation';

export const ReplyComment = ({
  projectId,
  isPrivateComment,
  fromPrivateDiscussion,
  onReply,
}) => {
  const replyCommentMsg = useTranslation('reply_small');
  const [readonly, setReadOnly] = useState(false);
  const [isPrivate, setIsPrivate] = useState(isPrivateComment);
  const handleReply = (content) => {
    setReadOnly(true);
    onReply?.({ content, isPrivate });
    setReadOnly(false);
  };

  const { hasAccessToResource } = useWithAccess();
  const projectResource = useProjectAsRBACResource(projectId);

  const canCreatePrivateConversation = hasAccessToResource({
    actionScope: ['PRIVATE'],
    rule: 'CONVERSATION:CREATE',
    resourceData: projectResource,
  });

  const canCreateSharedConversation = hasAccessToResource({
    actionScope: ['SHARED'],
    rule: 'CONVERSATION:CREATE',
    resourceData: projectResource,
  });

  const canToggleConversationPrivacy =
    canCreatePrivateConversation && canCreateSharedConversation;

  const handlePrivateBtnClick = useCallback(() => {
    if (!canToggleConversationPrivacy) {
      return;
    }
    setIsPrivate((prev) => !prev);
  }, [canToggleConversationPrivacy]);

  return (
    <div className={styles.reply}>
      <FormWithPrivacyHandler
        hidePrivateToggler={fromPrivateDiscussion}
        onSubmit={handleReply}
        isPrivate={isPrivate}
        readonly={readonly}
        placeholder={replyCommentMsg}
        onPrivateBtnClick={handlePrivateBtnClick}
        projectId={projectId}
        conversationPrivacy={{
          private:
            canCreatePrivateConversation && !canToggleConversationPrivacy,
          shared: canCreateSharedConversation && !canToggleConversationPrivacy,
          toggle: canToggleConversationPrivacy,
        }}
      />
    </div>
  );
};
